import React, { useEffect, useState } from 'react';
import { ListItem, Paper, Tooltip, Typography, TableCell, Grid } from '@material-ui/core';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { FaHeartbeat } from "react-icons/fa"; // Representa la salud
import { GiLungs } from "react-icons/gi";

export default function ListMediciones({ rows, isLoadUser, nameBascula, idBasula, primaryColor, busqueda, handleAñadirOximetria,handleAñadirCapacidad }) {
    const [datosUser, setDatosUser] = useState('-');

    useEffect(() => {
        if (rows?.user && rows.user.length > 0) {
            setDatosUser(rows.user[0].numerodocumento || '-');
        } else {
            setDatosUser('-');
        }
    }, [rows]);

    return (
        <>
            {isLoadUser ? (
                <></>
            ) : (
                <Paper style={{ marginBottom: '8px' }}>
                    <Grid container>
                        <TableCell style={{ width: '9%', wordWrap: 'break-word' }}>
                            <Typography>{datosUser}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '12%', wordWrap: 'break-word' }}>
                            <Typography>{rows.user[0]?.firstname || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.user[0]?.genero || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.imcs[0]?.imc?.toFixed(1) || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.igcs[0]?.igc?.toFixed(1) || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.user[0]?.peso || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.user[0]?.altura || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.oximetrias[0]?.oximetria || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{`${rows.presiones[0]?.sistolica}/${rows.presiones[0]?.diastolica}` || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.espirometrias[0]?.pred || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.espirometrias[0]?.porcentaje || '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '7%', wordWrap: 'break-word' }}>
                            <Typography>{rows.user[0]?.fecha_ultima_medicion ? UtilsDate().formatDDMMMYYYYHHmm(new Date(rows.user[0].fecha_ultima_medicion)) : '--'}</Typography>
                        </TableCell>
                        <TableCell style={{ width: '9%', whiteSpace: 'pre-wrap' }}>
                            <div style={{ display: 'flex', gap: '10px',marginLeft:'-25%' }}>
                                <ListItem button onClick={() => handleAñadirOximetria(datosUser)}>
                                    <Tooltip title="Registrar medición de Oximetría" aria-label="right-end">
                                        <div>
                                            <FaHeartbeat style={{ color: primaryColor, fontSize: '20px' }} />
                                        </div>
                                    </Tooltip>
                                </ListItem>
                                <ListItem button onClick={() => handleAñadirCapacidad(datosUser)}>
                                    <Tooltip title="Registrar capacidad pulmonar" aria-label="right-end">
                                        <div>
                                            <GiLungs style={{ color: primaryColor, fontSize: '20px' }} />
                                        </div>
                                    </Tooltip>
                                </ListItem>
                            </div>
                        </TableCell>
                    </Grid>
                </Paper>
            )}
        </>
    );
}
